import $ from 'jquery';
import Component from './Component';
import fg from 'fg-frontend/base';
import MultipleWidgetContainerItem from './MultiplyWidgetContainerItem';

export const removeStrategy = {
  BUTTONS: 'buttons',
  INPUT_HANDLER: 'inputhandler'
};

export default class MultipleWidgetContainer extends Component {
  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
    this.onClickAddItem = this.onClickAddItem.bind(this);
    this.onItemRemove = this.onItemRemove.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }
  getInitialState() {
    return {
      ...super.getInitialState(),
      ...{
        items: []
      }
    };
  }
  getDefaultProps() {
    return {
      /**
       * příznak určující zda je povoleno přidávání nebo odebírání nových položek
       * @type {boolean}
       */
      manipulationEnabled: false,
      /**
       * Omezení na maximální počet položek.
       * 0=neomezeně
       * @type {number}
       */
      maxItemsCount: 0,
      /**
       * Omezení kolik musí minimálně zůstat v kontejneru položek. U těch se nezobrazí tlačítko pro odebrání.
       * @type {number}
       */
      minItemsCount: 1,
      /**
       * Určuje strategii přidávání nových položek
       * enumerace strategii jak se bude přidávat nebo odebírat položky
       * BUTTONS = u každé položky se zobrazí tlačítka na odebrání a u poslední položky se zobrazí tlačítko na přidání
       * INPUT_HANDLER = Nebude zobrazeno tlačítko pro přidání, ale nové položky se budou přidávat na základě toho, jestli textinputy, textareje v předchozí položce obsahují nějakou hodnotu
       */

      addRemoveStrategy: removeStrategy.BUTTONS,
      /**
       * sablona tlacitka pro pridani
       */
      addItemBtnTemplate: '<button type="button" class="btn btn-default btn-sm" aria-label="Přidat">Přidat</button>',
      /**
       * sablona tlacitka pro odebrani
       */
      removeBtnTemplate: '<button type="button" class="btn btn-primary btn-sm" aria-label="Odebrat">Odebrat</button>',
      /**
       * nazev css tridy, ktera se prida ta toolbar s tlacitky
       */
      toolbarClassName: 'btn-toolbar',
      idReplacer: (id, index) => {
        //nahradí pouze čísla, která mají před sebou pomlčku "-"
        return id.replace(/([-])\d{1,4}/, function($1, $2){
          return $2 + index.toString();
        });
      },
      nameReplacer: (id, index) => {
        //nahradí pouze čísla, která mají před sebou pomlčku "-"
        return id.replace(/([!])\d{1,4}/, function($1, $2){
          return $2 + index.toString();
        });
      },
      //potencialne nespolehlive, potreba otestovat
      scriptReplacer: (text, index) => {
        return text.replace(/(\$\(('|")#.*?([-]))(\d{1,4})(.*?('|")\))/, function($1, $2, $3, $4, $5, $6, $7) {
          return $2 + index + $6;
        });
      }
    };
  }
  decorateInternal() {
    const {manipulationEnabled, addRemoveStrategy} = this.props;
    if (manipulationEnabled) {
      this.element.addClass('multiply-container-manipulation-enabled');
      if (addRemoveStrategy === addRemoveStrategy.BUTTONS) {
        this.element.addClass('multiply-container-has-add-button');
      }
    }
    const itemsElements = $.makeArray(this.element.find('.multiply-container-item'));

    //vytvoreni clonu DOMu z prvni polozky multiplyWidgetContaineru
    this.makeItemHTML(itemsElements[0]);


    itemsElements.forEach((itemElement) => {
      this.createNewItemComponent(itemElement);
    });


    if (manipulationEnabled) {
      this.placeAddNewItemToLastItem();
      this.addMaybeEmptyItem();
    }

    this.parentForm = this.element.parent('form');

  }
  onFormSubmit() {
    this.removeEmptyItems();
  }
  enterDocument() {
    super.enterDocument();
    if (this.parentForm) {
      this.parentForm.on('submit.' + this.getId(), this.onFormSubmit);
    }
  }
  /**
   *
   * @param {Element} element
   */
  makeItemHTML(element) {
    this.itemHTML = element.cloneNode(true);
  };

  getLastItemComponent() {
    const {items} = this.state;
    return items[items.length - 1];
  }
  onClickAddItem() {
    this.addItem();
  }
  getAddNewItemButton() {
    if (!this.addItemBtn) {
      this.addItemBtn = $(this.props.addItemBtnTemplate);
      this.addItemBtn.on('click', this.onClickAddItem);
    }
    return this.addItemBtn;
  }
  removeAddNewItemButton() {
    if (this.addItemBtn) {
      this.addItemBtn.off('click');
      this.addItemBtn.remove();
      this.addItemBtn = null;
    }
  }
  handleInput(e) {
    const input = e.target;
    if (input.value.length > 0) {
      this.addItem();
    }
  }
  placeAddNewItemToLastItem () {
    const {addRemoveStrategy, maxItemsCount} = this.props;
    const {items} = this.state;
    if (addRemoveStrategy === removeStrategy.BUTTONS) {
      if (items.length < maxItemsCount || maxItemsCount === 0) {
        this.getLastItemComponent().toolbar.append(this.getAddNewItemButton());
      }
      else {
        this.removeAddNewItemButton();
      }
    }
    else {
      if (this.inputHandler) {
        this.inputHandler.off('input', this.handleInput);
      }
      if (items.length < maxItemsCount || maxItemsCount == 0) {
        const lastInput = this.getLastInputFieldFromLastItem();
        if (lastInput.length > 0) {
          this.inputHandler = lastInput;
          lastInput.on('input', this.handleInput);
        }
      }
    }
  };
  onItemRemove(itemComponent) {
    this.removeItem(itemComponent);
  }

  /**
   *
   * @param {jQuery} element
   */
  createNewItemComponent(element) {
    const {removeBtnTemplate, toolbarClassName} = this.props;
    const {items} = this.state;

    const itemComponent = new MultipleWidgetContainerItem({
      onItemRemove: this.onItemRemove,
      removeBtnTemplate,
      toolbarClassName
    });
    itemComponent.decorate(element);

    items.push(itemComponent);

    this.setState({
      items: items
    });
  }

  addItem() {
    const {items} = this.state;
    const newItemIndex = items.length;
    const lastItemElement = this.getLastItemComponent().element;
    const newItemEl = this.getNewItemHtml(newItemIndex);

    lastItemElement.after(newItemEl);


    this.createNewItemComponent(newItemEl);
    this.placeAddNewItemToLastItem();

    $(newItemEl).trigger('afterContentsReplaced');
  }
  getNewItemHtml(index) {
    const newItemEl = this.itemHTML.cloneNode(true);
    const $newItemEl = $(newItemEl);
    this.replaceIdAndForAttributes($newItemEl, index);
    this.replaceDataSets($newItemEl, index);
    this.replacePossibleIdsInScript($newItemEl, index);
    this.clearPossibleValues($newItemEl);
    this.replaceLabels($newItemEl, index);
    this.replaceNameAttributes($newItemEl, index);
    this.removePossibleClassesAndAttributes($newItemEl);
    return newItemEl;
  }
  /**
   *
   * @param {jQuery} element
   * @param {number} index
   */
  replaceIdAndForAttributes(element, index) {
    let elementsWithId = $.makeArray(element.find('[id],[for]'));
    const {idReplacer} = this.props;
    elementsWithId.push(element[0]);
    elementsWithId.forEach((el) => {
      const idAttr = el.getAttribute('id');
      if (idAttr && idAttr.length > 0) {
        el.setAttribute('id', idReplacer(idAttr, index));
      }
      const forAttr = el.getAttribute('for');
      if (forAttr && forAttr.length > 0) {
        el.setAttribute('for', idReplacer(forAttr, index));
      }
    });
  };

  /**
   *
   * @param {jQuery} element
   */
  clearPossibleValues(element) {
    const inputsWithValues = element.find('input[value], textarea:not(:empty),select');
    inputsWithValues.each((index, input) => {
      if (input.type.toLowerCase() == 'checkbox' || input.type.toLowerCase() == 'radio') {
        input.removeAttribute('checked');
      }
      else {
        input.value = '';
      }
    });
  };

  /**
   * Slouzi pro replace textovych informaci.
   * V labelu se muze vyskytovat i input elementy
   * Dela tedy replace jen v textovych nodech.
   * @param {jQuery} element
   * @param {number} index
     */
  replaceLabels(element, index) {
    const labels = element.find('label');

    const textNodesUnder = node => {
      let all = [];
      for (node = node.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === 3) {
          all.push(node);
        }
        else all = all.concat(textNodesUnder(node));
      }
      return all;
    };

    labels.each((i, label) => {
      textNodesUnder(label).forEach(textNode => {
        textNode.nodeValue = textNode.nodeValue.replace(/(\d){1,4}/, function($1){
          return index + 1;
        });
      });
    });
  };
  /**
   *
   * @param {jQuery} element
   * @param {number} index
   */
  replaceDataSets(element, index) {
    const elementsWithDataSets = element.find('[data-target-hidden-input]');
    elementsWithDataSets.add(element);
    const {idReplacer} = this.props;
    elementsWithDataSets.each((i, el) => {
      const dataAttr = el.getAttribute('data-target-hidden-input');
      if (dataAttr && dataAttr.length > 0) {
        el.setAttribute('data-target-hidden-input', idReplacer(dataAttr, index));
      }
    });
  };

  replaceNameAttributes(element, index) {
    let elementsWithId = element.find('[name]');
    const {nameReplacer} = this.props;
    elementsWithId.add(element);
    elementsWithId.each((i, el) => {
      const nameAttr = el.getAttribute('name');
      if (nameAttr && nameAttr.length > 0) {
        el.setAttribute('name', nameReplacer(nameAttr, index));
      }
    });
  }

  replacePossibleIdsInScript(element, index) {
    const textNodesUnder = node => {
      let all = [];
      for (node = node.firstChild; node; node = node.nextSibling) {
        if (node.nodeType === 3) {
          all.push(node);
        }
        else all = all.concat(textNodesUnder(node));
      }
      return all;
    };
    const {scriptReplacer} = this.props;
    textNodesUnder(element[0]).forEach(textNode => {
      textNode.nodeValue = scriptReplacer(textNode.nodeValue, index);
    });
  }

  /**
   *
   * @param {jQuery} element
   */
  removePossibleClassesAndAttributes(element) {
    const classesToRemove = ['error', 'has-success', 'has-error'];
    const elements = element.find('.' + classesToRemove.join(',.'));
    elements.each((i, el) => {
      $(el).removeClass(classesToRemove.join(' '));
    });
  };

  addMaybeEmptyItem() {
    const {addRemoveStrategy, maxItemsCount} = this.props;
    const {items} = this.state;
    if (addRemoveStrategy === removeStrategy.INPUT_HANDLER && (items.length < maxItemsCount || maxItemsCount == 0)) {
      const input = this.getLastInputFieldFromLastItem();
      if (input.length > 0 && input[0].value.length > 0) {
        this.addItem();
      }
    }
  }
  getLastInputFieldFromLastItem() {
    return this.getLastItemComponent().getLastInputField();
  }

  removeItem(item) {
    const {items} = this.state;
    const elToRemove = item.element;

    elToRemove.trigger('beforeContentsReplaced');

    const index = items.indexOf(item);
    items.splice(index, 1);

    this.setState({
      items: items
    });
    this.placeAddNewItemToLastItem();
    item.dispose();
    if (index < items.length) {
      this.refreshItemsAfterRemove(index);
    }
    elToRemove.remove();
  };

  refreshItemsAfterRemove(indexOfRemovedChild) {
    const {items} = this.state;
    items.forEach((item, index) => {
      if (index >= indexOfRemovedChild) {
        const el = item.element;
        this.replaceIdAndForAttributes(el, index);
        this.replaceLabels(el, index);
        this.replaceNameAttributes(el, index);
      }
    });
  }
  getEmptyItems() {
    let notFilledItems = [];
    this.state.items.forEach((child) => {
      if (!child.hasValue()) {
        notFilledItems.push(child);
      }
    });
    return notFilledItems;
  }
  removeEmptyItems() {
    const emptyItems = this.getEmptyItems();
    emptyItems.forEach(item => this.removeItem(item));
  };
  updateRemoveButtons() {
    const {items} = this.state;
    const {minItemsCount, manipulationEnabled} = this.props;
    if (manipulationEnabled) {
      if (items.length > minItemsCount) {
        items.forEach(item => item.setProps({removable: true}));
      } else {
        for (let i = 0; i < minItemsCount; i++) {
          items[i].setProps({removable: false});
        }
      }
    }
  }
  updateInternal() {
    this.updateRemoveButtons();
  }
  dispose() {
    this.parentForm.off('submit.' + this.getId(), this.onFormSubmit);
    this.parentForm = null;
    this.removeAddNewItemButton();
    super.dispose();
  }
}

MultipleWidgetContainer.COMPONENT_NAME = 'MultipleWidgetContainer';
fg.makeJQueryPlugin(MultipleWidgetContainer);



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/MultipleWidgetContainer/MultipleWidgetContainer.component.js